import emptyInnerHTML from '@/common/helpers/empty-inner-html';

export default function (value, condition, blankString = emptyInnerHTML) {
    return condition ? blankString : value;
}
